import styled from "styled-components"
import logoIcon from "../../assets/images/icon.png"
import darkLogoIcon from "../../assets/images/dark-icon.png"
import { useMobergTheme } from "../../Providers/MobergThemeProvider"

/**
 * Branded loading spinner with Moberg cloud logo centered inside a gradient arc ring.
 * Adapts to light/dark mode automatically.
 *
 * @param {number} [size=100] - Overall size in px
 */
export function MobergLogoSpinner({ size = 100 }) {
    const { colorScheme } = useMobergTheme()
    const isDark = colorScheme === "dark"
    const logoSize = Math.round(size * 0.48)

    return (
        <SpinnerContainer $size={size}>
            <SpinnerRing $size={size} />
            <LogoImage src={isDark ? darkLogoIcon : logoIcon} alt="Moberg" $size={logoSize} />
        </SpinnerContainer>
    )
}

const SpinnerContainer = styled.div`
    position: relative;
    width: ${props => props.$size}px;
    height: ${props => props.$size}px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const SpinnerRing = styled.div`
    position: absolute;
    inset: 0;
    border-radius: 50%;
    animation: mobergSpin 1.4s linear infinite;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: conic-gradient(
            from 0deg,
            transparent 0%,
            transparent 25%,
            var(--color-accent-interactive) 95%,
            transparent 100%
        );
        mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px));
        -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2.5px));
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 3px;
        height: 3px;
        transform: translateX(-50%);
        border-radius: 50%;
        background: var(--color-accent-interactive);
    }

    @keyframes mobergSpin {
        to { transform: rotate(360deg); }
    }
`

const LogoImage = styled.img`
    width: ${props => props.$size}px;
    height: ${props => props.$size}px;
    object-fit: contain;
    animation: logoBreath 2.4s ease-in-out infinite;

    @keyframes logoBreath {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.6; }
    }
`
